import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { IceapiService, ManagementApiService, UserUtilityService } from '../../../../../services';
import { GlobalEmittersService } from '../../../../../services/global-emitters.service';
import { MeasurementService } from '../../../../../services/measurement.service';
import { TighteningMethod } from '../../../enums/tightening-method.enum';
import { CalculationResult, ToolOutput } from '../../../models/calculationModels';
import { CalculationPercentageSettingsComponent } from '../calculation-percentage-settings/calculation-percentage-settings';
import { ErrorDialogComponent } from 'src/app/shared/info-dialogs/error-dialog/error-dialog.component';
import { UserSettingModel } from 'src/app/Modules/settings/models/informate/user-setting-model';
import { InstanceSettingModel, PreferencesModel as UserPreferencesModel } from 'src/app/Modules/settings/models/informate/instance-setting-model';
import { CalculationPreferencesCalcResultsComponent, CalculationPreferencesPassPctComponent } from 'src/app/Modules/settings/components';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';
@Component({
    selector: 'app-pump-output',
    templateUrl: './pump-output.component.html',
    styleUrls: ['./pump-output.component.scss'],
    standalone: false
})
export class PumpOutputComponent implements OnInit {
    @Input()
    set calcOutput(value: CalculationResult) {
        this._calcOutput = value;
        if (value !== undefined && value != null) {
            this.loadTorque();
            this.ShowSettings = this.calcOutput?.input?.others?.tighteningMethod === TighteningMethod.Torque;
        }
    }
    get calcOutput(): CalculationResult {
        return this._calcOutput;
    }

    @Input()
    set selectedTool(value: ToolOutput) {
        this._selectedTool = value;
        if (value !== undefined && value != null) {
            this.loadPumpPressure();
        }
    }

    @Input() displayIDMSSettings: boolean;

    get selectedTool(): ToolOutput {
        return this._selectedTool;
    }

    profileSettingAreaId: string;
    pumpPressures: any[];
    torques: number[];
    passValues: string[] = [];
    pumpPressureUnit: string;
    torqueUnit: string;
    ShowSettings = false;
    isSubscribe: Subject<any> = new Subject<any>();
    userSettings: InstanceSettingModel[];
    calculationPreferenceSettings: InstanceSettingModel[];
    formatedCalculationPreferenceSettings: UserPreferencesModel[];
    isRecalculated: boolean = false;
    isToolSelected: boolean = false;
    private _selectedTool: ToolOutput;
    private _calcOutput: CalculationResult;

    constructor(
        private ngbModal: NgbModal,
        private measSvc: MeasurementService,
        private mgmtSvc: ManagementApiService,
        private iceApiService: IceapiService,
        private cd: ChangeDetectorRef,
        private globalEmittersService: GlobalEmittersService,
        private user_utility: UserUtilityService,
        private router: Router
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.displayIDMSSettings && this.formatedCalculationPreferenceSettings?.length > 0) {
            this.loadTorque();
        }
    }

    ngOnInit(): void {
        if (this.router.url === '/idms/plantmanager') {
            this.displayIDMSSettings = true;
        }

        this.iceApiService.calculationRes.subscribe((res) => {
            if (res) {
                this.pumpPressures = [];
                this.torques = [];
                this.passValues = [];
                this.selectedTool = null;
                this.cd.detectChanges();
            }
        });

        this.getSettings();

        this.globalEmittersService.isIdmsPreferenceSettingUpdated.pipe(takeUntil(this.isSubscribe)).subscribe((res) => {
            if (res) {
                this.getSettings();
            }
        });
        this.globalEmittersService.isToolSelected.pipe(takeUntil(this.isSubscribe)).subscribe((res) => {
            this.isToolSelected = res;
            this.cd.detectChanges();
        });
    }

    loadPumpPressure() {
        if (this.router.url === '/idms/plantmanager') {
            this.displayIDMSSettings = true;
        }
        this.pumpPressureUnit = this.measSvc.getUserPreferedUnitSuffix(UnitType.DefaultPressureUnit);
        this.passValues = [];
        this.pumpPressures = [];
        if (this.calcOutput !== null) {
            if (this.calcOutput?.input?.others?.tighteningMethod == TighteningMethod.Tension) {
                //Pass1
                this.passValues.push('Pass1');
                this.pumpPressures.push(this.measSvc.getUserPreferedValueWithoutUnit(this.selectedTool.pass1, UnitType.DefaultPressureUnit));
                //Pass2
                if (this.selectedTool?.pass2 != undefined && this.selectedTool?.pass2 != null) {
                    this.passValues.push('Pass2');
                    this.pumpPressures.push(this.measSvc.getUserPreferedValueWithoutUnit(this.selectedTool.pass2, UnitType.DefaultPressureUnit));
                }
                //Pass3
                if (this.selectedTool?.pass3 != undefined && this.selectedTool?.pass3 !== null) {
                    this.passValues.push('Pass3');
                    this.pumpPressures.push(this.measSvc.getUserPreferedValueWithoutUnit(this.selectedTool.pass3, UnitType.DefaultPressureUnit));
                }
                //Pass4
                if (this.selectedTool?.pass4 != undefined && this.selectedTool?.pass4 !== null) {
                    this.passValues.push('Pass4');
                    this.pumpPressures.push(this.measSvc.getUserPreferedValueWithoutUnit(this.selectedTool.pass4, UnitType.DefaultPressureUnit));
                }
            } else {
                // Pass1
                this.managePumpPressure(this.selectedTool?.requiredPressure1, this.calcOutput?.output?.general?.torquePercentageText1);
                // Pass2
                this.managePumpPressure(this.selectedTool?.requiredPressure2, this.calcOutput?.output?.general?.torquePercentageText2);

                // Pass3
                this.managePumpPressure(this.selectedTool?.requiredPressure3, this.calcOutput?.output?.general?.torquePercentageText3);
                // Pass4
                this.managePumpPressure(this.selectedTool?.requiredPressure4, this.calcOutput?.output?.general?.torquePercentageText4);

                this.loadTorque();
            }
        }
    }

    managePumpPressure(requiredPressure, pass) {
        if (requiredPressure !== null && pass) {
            // this.passValues.push(this.mgmtSvc.userDefaults.find(x => x.userPreferenceKey == 'Calculation_Pass1_Text').userPreference + ' - ' + this.mgmtSvc.userDefaults.find(x => x.userPreferenceKey == 'Calculation_Pass1_Value').userPreference);

            if (this.selectedTool.isPowered) {
                this.pumpPressures.push(this.measSvc.getUserPreferedValueWithoutUnit(requiredPressure, UnitType.DefaultPressureUnit));
            } else {
                this.pumpPressures.push('N/A');
            }
        }
    }

    getSafeValue(value: any): string | any {
        if (value == undefined || value == null || value == '') {
            return '';
        } else {
            return value;
        }
    }

    checkValues(a: any, b: any): string {
        const hasValue = (val: any) => val !== undefined && val !== null && val !== '';

        return hasValue(a) && hasValue(b) ? ' - ' : '';
    }

    loadTorque() {
        if (this.router.url === '/idms/plantmanager') {
            this.displayIDMSSettings = true;
        }

        this.torques = [];
        let isPass1 = this.checkUserprefrences('Calculation_Pass1_Visible');
        let isPass2 = this.checkUserprefrences('Calculation_Pass2_Visible');
        let isPass3 = this.checkUserprefrences('Calculation_Pass3_Visible');
        let isPass4 = this.checkUserprefrences('Calculation_Pass4_Visible');

        if (this.calcOutput?.input?.others?.tighteningMethod == TighteningMethod.Torque) {
            this.torqueUnit = this.measSvc.getUserPreferedUnitSuffix(UnitType.DefaultTorqueUnit);
            this.torques = [];
            this.passValues = [];

            if (this.displayIDMSSettings && this.calcOutput?.output?.general?.torquePercentageText1) {
                   this.torques.push(
                        this.measSvc.getUserPreferedValueWithoutUnit(
                            this.calcOutput.output.general.torqueLongForm1 ?? this.calcOutput.output.general.torqueShortForm1,
                            UnitType.DefaultTorqueUnit
                        )
                    );             

                this.passValues.push(this.calcOutput?.output?.general?.torquePercentageText1 + ' - ' + this.calcOutput?.output?.general?.torquePercentage1);
            } else if (isPass1 && !this.displayIDMSSettings) {
                this.torques.push(
                    this.measSvc.getUserPreferedValueWithoutUnit(
                        this.calcOutput.output.general.torqueLongForm1 ?? this.calcOutput.output.general.torqueShortForm1,
                        UnitType.DefaultTorqueUnit
                    )
                );
                this.passValues.push(
                    this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass1_Text').userPreference +
                        ' - ' +
                        this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass1_Value').userPreference
                );
            }

            if (this.displayIDMSSettings && this.calcOutput?.output?.general?.torquePercentageText2) {
                 this.torques.push(
                    this.measSvc.getUserPreferedValueWithoutUnit(
                        this.calcOutput.output.general.torqueLongForm2 ?? this.calcOutput.output.general.torqueShortForm2,
                        UnitType.DefaultTorqueUnit
                    )
                );
                
                this.passValues.push(this.calcOutput?.output?.general?.torquePercentageText2 + ' - ' + this.calcOutput?.output?.general?.torquePercentage2);
            } else if (isPass2 && !this.displayIDMSSettings) {
                this.torques.push(
                    this.measSvc.getUserPreferedValueWithoutUnit(
                        this.calcOutput.output.general.torqueLongForm2 ?? this.calcOutput.output.general.torqueShortForm2,
                        UnitType.DefaultTorqueUnit
                    )
                );
                this.passValues.push(
                    this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass2_Text').userPreference +
                        ' - ' +
                        this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass2_Value').userPreference
                );
            }

            if (this.displayIDMSSettings && this.calcOutput?.output?.general?.torquePercentageText3) {
                 this.torques.push(
                    this.measSvc.getUserPreferedValueWithoutUnit(
                        this.calcOutput.output.general.torqueLongForm3 ?? this.calcOutput.output.general.torqueShortForm3,
                        UnitType.DefaultTorqueUnit
                    )
                );
               
                this.passValues.push(this.calcOutput?.output?.general?.torquePercentageText3 + ' - ' + this.calcOutput?.output?.general?.torquePercentage3);
            } else if (isPass3 && !this.displayIDMSSettings) {
                this.torques.push(
                    this.measSvc.getUserPreferedValueWithoutUnit(
                        this.calcOutput.output.general.torqueLongForm3 ?? this.calcOutput.output.general.torqueShortForm3,
                        UnitType.DefaultTorqueUnit
                    )
                );
                this.passValues.push(
                    this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass3_Text').userPreference +
                        ' - ' +
                        this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass3_Value').userPreference
                );
            }

            if (this.displayIDMSSettings && this.calcOutput?.output?.general?.torquePercentageText4) {
                 this.torques.push(
                    this.measSvc.getUserPreferedValueWithoutUnit(
                        this.calcOutput.output.general.torqueLongForm4 ?? this.calcOutput.output.general.torqueShortForm4,
                        UnitType.DefaultTorqueUnit
                    )
                );               

                this.passValues.push(this.calcOutput?.output?.general?.torquePercentageText4 + ' - ' + this.calcOutput?.output?.general?.torquePercentage4);
            } else if (isPass4 && !this.displayIDMSSettings) {
                this.torques.push(
                    this.measSvc.getUserPreferedValueWithoutUnit(
                        this.calcOutput.output.general.torqueLongForm4 ?? this.calcOutput.output.general.torqueShortForm4,
                        UnitType.DefaultTorqueUnit
                    )
                );
                this.passValues.push(
                    this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass4_Text').userPreference +
                        ' - ' +
                        this.mgmtSvc.userDefaults.find((x) => x.userPreferenceKey == 'Calculation_Pass4_Value').userPreference
                );
            }

            this.cd.detectChanges();
        }
    }

    openCalculationResultSettingsModal() {
        this.mgmtSvc.getSettingProfileAreaId('informate').subscribe((res) => {
            if (res.success === true) {
                let profileSettingAreaId = res.response.settingAreaId;
                if (profileSettingAreaId) {
                    let dialogRef = null;
                    dialogRef = this.ngbModal.open(CalculationPercentageSettingsComponent, {
                        size: 'lg',
                    });

                    dialogRef.componentInstance.selectedTool = this.selectedTool;
                    dialogRef.componentInstance.profileSettingAreaId = profileSettingAreaId;
                    dialogRef.componentInstance.displayIDMSSettings = this.displayIDMSSettings;
                    dialogRef.componentInstance.userSettingsIDMS = this.userSettings;

                    dialogRef.result
                        .then((res: any) => {
                            if (res) {
                                setTimeout(() => {
                                    this.globalEmittersService.LoadCalculation.next(true);
                                }, 3000);
                            }
                        })
                        .catch((error) => {
                            console.warn(error);
                        });
                } else {
                    let dialogRef = this.ngbModal.open(ErrorDialogComponent);
                    dialogRef.componentInstance.message = res.message;
                }
            }
        });
    }
    checkUserprefrences(userPrefferd) {
        return this.mgmtSvc.userDefaults.find((item) => item.userPreferenceKey == userPrefferd).userPreference === 'True' ? true : false;
    }

    getSettings(): void {
        this.mgmtSvc.getSettingProfileAreaId('informate').subscribe((res) => {
            if (res.success === true) {
                this.profileSettingAreaId = res.response.settingAreaId;
                if (this.profileSettingAreaId) {
                    this.mgmtSvc.getSettingbySettinfAreaIdForIdms(this.profileSettingAreaId).subscribe((userSettings) => {
                        if (userSettings.success === true) {
                            this.userSettings = userSettings.response;
                            this.calculationPreferenceSettings = this.getSectionData('Calculation Preferences', false);

                            this.formatedCalculationPreferenceSettings = this.calculationPreferenceSettings.map((item) => ({
                                key: item.setting.key,
                                name: item.setting.name,
                                value: item.value,
                                default: item.setting.default,
                            }));

                            if (this.displayIDMSSettings && this.formatedCalculationPreferenceSettings?.length > 0) {
                                this.loadTorque();
                            }
                        } else {
                            this.user_utility.errorModelPopup(userSettings.message);
                        }
                    });
                }
            } else {
                this.user_utility.errorModelPopup(res.message);
            }
        });
    }

    getSectionData(sectionName: string, isSubSection: boolean = false): InstanceSettingModel[] {
        const sections: InstanceSettingModel[] = this.userSettings.filter((item: InstanceSettingModel) => {
            if (isSubSection) {
                return item.setting.settingSubSection?.name.toLowerCase() === sectionName.toLowerCase();
            }

            return item.setting.settingSubSection?.settingSection.name.toLowerCase() === sectionName.toLowerCase();
        });

        return sections;
    }
}
